import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

document.addEventListener('DOMContentLoaded', () => {
    const heroContainers = document.querySelectorAll('.swipper-projekty-hero');
    heroContainers.forEach(container => {
        initHeroSwipper(container);
    });

    const filterContainers = document.querySelectorAll('.swipper-projekty-filter');
    filterContainers.forEach(container => {
        initProjektySwipper(container);
    });
});

function initHeroSwipper(container) {
    const swiperContainer = container.querySelector('.swiper-container');
    if (!swiperContainer) return;

    const swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: '.swipper-projekty-hero .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"></span>';
            }
        },
    });
}

function initProjektySwipper(container) {
    // Najde swiper container uvnitř předaného kontejneru
    const swiperContainer = container.querySelector('.swiper-container');
    if (!swiperContainer) return;

    // Inicializace Swiperu pomocí elementů v rámci daného kontejneru
    const swiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 50,
        slidesOffsetBefore: 0,
        navigation: {
            nextEl: container.querySelector('.swiper-button-next'),
            prevEl: container.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 50,
            },
        },
    });


    // Nastavení pro filtrování v této instanci
    const loader = container.querySelector('#carousel-loader');
    const itemsContainer = container.querySelector('.swiper-wrapper');
    if (!itemsContainer) return;

    // Uložíme všechny slidy při inicializaci
    const allSlides = Array.from(itemsContainer.querySelectorAll('.swiper-slide'));
    // Vyhledáme tlačítka pro filtrování v rámci kontejneru
    const categoryButtons = container.querySelectorAll('.projekty-category-button');

    categoryButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (loader) {
                loader.classList.remove('hidden-x');
            }

            // Smažeme aktivní stav u všech tlačítek
            categoryButtons.forEach(clear => {
                clear.classList.remove('filter-active');
            });
            button.classList.add('filter-active');

            setTimeout(() => {
                const category = button.getAttribute('data-category');

                // Namísto odstranění slidů je jednoduše skryjeme nebo zobrazíme
                allSlides.forEach(slide => {
                    // Získání atributu data-categories a vytvoření pole oříznutých hodnot
                    let dataCats = slide.getAttribute('data-categories');
                    let cats = dataCats ? dataCats.split(',').map(tag => tag.trim()) : [];

                    // Pokud je vybrána kategorie "all" nebo slide obsahuje daný post_tag, zobrazíme slide
                    if (category === 'all' || cats.includes(category)) {
                        slide.classList.remove('hidden-x');
                    } else {
                        slide.classList.add('hidden-x');
                    }
                });

                swiper.update();
                swiper.slideTo(0);

                if (loader) {
                    loader.classList.add('hidden-x');
                }
            }, 300);
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const backBtn = document.getElementById('go-back');
    if (backBtn) {
        backBtn.addEventListener('click', (e) => {
            e.preventDefault();
            history.go(-1);
        });
    }
});
